import type {IdentityProviderT} from '@freckle/educator-entities/ts/roster/identity-provider'
import {getIdpLabel} from '@freckle/educator-entities/ts/roster/identity-provider'
import {Container} from '@freckle/educator-materials/ts/components/container'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {H2} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import type {UnmanagedCourseT} from '@freckle/school/ts/common/models/unmanaged-course'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import {CleanUpCourses} from '@freckle/school/ts/rostering/components/clean-up-roster/clean-up-courses'
import {CleanUpSelfRosteredTeachers} from '@freckle/school/ts/rostering/components/clean-up-roster/clean-up-self-rostered-teachers'
import ConfirmButton from '@freckle/school/ts/rostering/components/common/confirm-button'
import {MergeDuplicateStudents} from '@freckle/school/ts/rostering/components/common/merge-duplicate-students'

type Props = {
  onMerge: () => void
  cleanUpCourses: boolean
  onChange: () => void
  numSelfRosteredTeachers: number
  activeIdps: Set<IdentityProviderT>
  initialUnmanagedCourses: Array<UnmanagedCourseT>
  numUnmanagedStudents: number
}

export function CleanUpRoster(props: Props) {
  const {
    onMerge,
    cleanUpCourses,
    onChange,
    numSelfRosteredTeachers,
    activeIdps,
    initialUnmanagedCourses,
    numUnmanagedStudents,
  } = props

  const {t} = useSafeTranslation()

  const buttonText = cleanUpCourses
    ? t('CLEAN_UP_ROSTER_MERGE_DUPES_AND_REVIEW')
    : t('CLEAN_UP_ROSTER_CONFIRM_MERGE_DUPES')

  const idps = Array.from(activeIdps)

  const activeIdpsString = idps.length === 1 ? getIdpLabel(t, idps[0]) : t('IDPS_PLURALIZED')

  return (
    <>
      <Container>
        <H2>{t('CLEAN_UP_ROSTER_H2_MERGE_DUPLICATES_TITLE')}</H2>

        <MergeDuplicateStudents
          isChecked
          numUnmanagedStudents={numUnmanagedStudents}
          activeIdpsString={activeIdpsString}
        />

        <br />

        <CleanUpCourses
          isChecked={cleanUpCourses}
          onChange={onChange}
          numUnmanagedCourses={initialUnmanagedCourses.length}
          activeIdpsString={activeIdpsString}
        />

        <ConfirmButton
          onConfirm={onMerge}
          dataTest="confirm-merge-duplicates"
          text={buttonText}
          warn={t('CLEAN_UP_ROSTER_CONFIRM_BUTTON_WARNING')}
          style="secondary"
        />
      </Container>
      <br />

      <CleanUpSelfRosteredTeachers
        numSelfRosteredTeachers={numSelfRosteredTeachers}
        activeIdpsString={activeIdpsString}
      />

      <br />
      <Link reactRouter href={Routes.dashboard()} style="btn-primary">
        {t('CLEAN_UP_ROSTER_LINK_BACK')}
      </Link>
    </>
  )
}
